import apiClient from './api';
import { Category } from '@citiguide/shared';

/** Shape of GET /api/categories/groups (hand-kept copy of public-backend's PublicCategoryTree). */
export interface PublicCategoryTree {
  group: Array<{
    id: string;
    name: string;
    description?: string;
    baseIcon?: string;
    type?: number;
    dimension?: string;
  }>;
  category: Array<{
    id: string;
    name: string;
    description?: string;
    gId?: string;
    parentCategoryId?: string;
    icon?: string;
    shortname?: string;
    dimension?: string;
    order?: number;
  }>;
}

const EMPTY_TREE: PublicCategoryTree = { group: [], category: [] };

/** Anything that is not the {group, category} tree (e.g. an older API's bare array) becomes an empty tree. */
export const normalizeCategoryTree = (data: unknown): PublicCategoryTree => {
  const tree = data as Partial<PublicCategoryTree> | null | undefined;
  if (tree && !Array.isArray(tree) && Array.isArray(tree.group) && Array.isArray(tree.category)) {
    return { group: tree.group, category: tree.category };
  }
  return EMPTY_TREE;
};

export const categoryService = {
  /**
   * Get all categories (public read-only)
   * Public backend filters by subdomain automatically
   */
  getCategories: async (): Promise<Category[]> => {
    const response = await apiClient.get<Category[]>('/api/categories');
    return response.data;
  },

  /**
   * Get the category tree: groups and categories (public read-only)
   */
  getCategoriesWithGroups: async (): Promise<PublicCategoryTree> => {
    const response = await apiClient.get<unknown>('/api/categories/groups');
    return normalizeCategoryTree(response.data);
  },

  /**
   * Get a single category by ID (public read-only)
   */
  getCategory: async (categoryId: string): Promise<Category> => {
    const response = await apiClient.get<Category>(`/api/categories/${categoryId}`);
    return response.data;
  },
};
